import styled from 'styled-components';

// Blog Page Container
export const BlogPageContainer = styled.div.attrs(() => ({
  className: 'bg-gray-100 py-10 px-10',
}))``;

// Blog Grid
export const BlogGrid = styled.div.attrs(() => ({
  className: 'max-w-full mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8',
}))``;

// Blog Card
export const BlogCard = styled.div.attrs(() => ({
  className:
    'bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 ease-in-out hover:shadow-2xl',
}))``;

// Blog Image
export const BlogImage = styled.img.attrs(() => ({
  className: 'w-full h-[400px] object-cover transition-all duration-300 ease-in-out hover:opacity-50',
}))``;

// Blog Content
export const BlogContent = styled.div.attrs(() => ({
  className: 'p-6 relative',
}))``;

// Blog Date
export const BlogDate = styled.p.attrs(() => ({
  className: 'text-sm text-gray-500',
}))``;

// Blog Title
export const BlogTitle = styled.h2.attrs(() => ({
  className: 'text-xl font-semibold mt-3 cursor-pointer hover:text-blue-500',
}))``;

// Blog Description
export const BlogDescription = styled.p.attrs(() => ({
  className:
    'overflow-hidden transition-all duration-300 ease-in-out max-h-0 opacity-0 text-gray-700 mt-3 group-hover:max-h-40 group-hover:opacity-100',
}))``;

// Read More Button
export const ReadMoreButton = styled.button.attrs(() => ({
  className:
    'text-blue-500 hover:text-blue-700 mt-4 block font-semibold opacity-0 translate-y-4 transition-all duration-300 ease-in-out group-hover:opacity-100 group-hover:translate-y-0',
}))``;
